class CartDrawerRecommendations extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    const swiperContainer = this.querySelector('.cart-drawer-recommendes-slider');
    
    if (!swiperContainer) return;

    this.swiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 16,
      slidesPerGroup: 1,
      navigation: {
        nextEl: this.querySelector('.cart-drawer-recommendes-nav-btn.next'),
        prevEl: this.querySelector('.cart-drawer-recommendes-nav-btn.prev'),
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      loop: false,
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }
}

customElements.define('cart-drawer-recommendations', CartDrawerRecommendations);
